/* eslint-disable operator-linebreak */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classNames from 'classnames';

// constants
import { BFR } from '../../lib/Constants';

// containers
import GasSavings from '../GasSavings';
import ComingSoon from '../ComingSoon';

// components
import Btn from '../../components/Btn';

// helpers
import { i18n, fixLocalePath } from '../../lib/Utils';

import m3TestDriveLocales from '../../data/m3Availabilities';

const RouteSummaryPropTypes = {
  directionsLoaded: PropTypes.bool.isRequired, // If the directions have successfully returned from API
  shortName: PropTypes.string.isRequired, // Abbreviated vehicle model name (MS|MX|M3)
  isMobile: PropTypes.bool.isRequired, // Is this a mobile device
  modelCode: PropTypes.string.isRequired, // Model code passed to the routing API
  CTA: PropTypes.shape({}).isRequired, // All properties for vehicle specific primary and secondary CTA's
  vehicleToggle: PropTypes.bool.isRequired, // State of the Vehicle selector
  directionsIsLoading: PropTypes.bool.isRequired, // If the directions are loading
  locale: PropTypes.string.isRequired, // Current user locale "en_US"
  region: PropTypes.string.isRequired, // Current user region "US"
};

const RouteSummaryDefaultProps = {};

class RouteSummary extends Component {
  constructor(props) {
    super(props);

    this.handleCTAClick = this.handleCTAClick.bind(this);
    this.handleTestDriveClick = this.handleTestDriveClick.bind(this);
  }

  handleCTAClick() {
    const { modelCode, locale } = this.props;
    let primaryHref;

    switch (modelCode) {
      case 'MS':
        primaryHref = '/models/design';
        break;
      case 'MX':
        primaryHref = '/modelx/design';
        break;
      case 'M3':
        primaryHref = '/model3/design';
        break;
      case 'MY':
        primaryHref = '/modely/design';
        break;
      default:
        primaryHref = '/';
    }

    // TODO: locale is a temporary fix until SDL connector is working
    const localeStr = fixLocalePath(locale);
    window.open(`${localeStr}${primaryHref}`);
  }

  handleTestDriveClick() {
    const { modelCode, locale, region } = this.props;

    let secondaryHref = '/drive';

    if (modelCode === 'M3' && m3TestDriveLocales.includes(region) === false) {
      secondaryHref = '/updates';
    }

    // TODO: locale is a temporary fix until SDL connector is working
    const localeStr = fixLocalePath(locale);
    window.open(`${localeStr}${secondaryHref}`);
  }

  render() {
    const {
      directionsLoaded,
      shortName,
      isMobile,
      modelCode,
      CTA,
      vehicleToggle,
      directionsIsLoading,
      region,
    } = this.props;
    let secondaryCTALabel;
    let secondaryCTALabelMobile;
    let secondaryCTAAnalytics;

    const hideRouteSummary = modelCode === 'M3' && m3TestDriveLocales.includes(region) === false;
    const showBtns =
      CTA.vehicles &&
      Object.getOwnPropertyNames(CTA.vehicles).length > 0 &&
      modelCode !== BFR;

    if (CTA.vehicles) {
      secondaryCTALabel = CTA.vehicles.testDriveLabel;
      secondaryCTALabelMobile = CTA.vehicles.mobileTestDriveLabel;
      secondaryCTAAnalytics = 'test_drive';

      if (modelCode === 'M3' && m3TestDriveLocales.includes(region) === false) {
        secondaryCTALabel = CTA.vehicles.stayUpdatedLabel;
        secondaryCTALabelMobile = CTA.vehicles.mobileStayUpdatedLabel;
        secondaryCTAAnalytics = 'stay_updated';
      }
    }

    if (directionsLoaded) {
      // eslint-disable-next-line arrow-parens
      const componentRef = el => {
        this.component = el;
      };
      return (
        <div
          className={classNames('route', {
            'route--mobile route--slide-up': isMobile && directionsLoaded,
            hidden: vehicleToggle || directionsIsLoading,
          })}
          ref={componentRef}
        >
          <div className="route__summary">
            {!hideRouteSummary && <GasSavings />}
            <ComingSoon />
            {showBtns && (
              <div>
                <Btn
                  styles="btn-primary route__cta route__cta--order"
                  handleClick={this.handleCTAClick}
                  analytics={{
                    interaction: 'cta',
                    label: i18n('order'),
                  }}
                >
                  {i18n(CTA.vehicles.primaryCTALabel, {
                    MODEL: shortName,
                  })}
                </Btn>
                <Btn
                  styles={classNames('route__cta route__cta--test-drive', {
                    'btn-secondary': isMobile && directionsLoaded,
                  })}
                  handleClick={this.handleTestDriveClick}
                  analytics={{
                    interaction: 'cta',
                    label: i18n(secondaryCTAAnalytics),
                  }}
                >
                  {!isMobile && (
                    <p className="copy">{i18n(secondaryCTALabel)}</p>
                  )}
                  {isMobile && i18n(secondaryCTALabelMobile)}
                </Btn>
              </div>
            )}
          </div>
        </div>
      );
    }

    return null;
  }
}

RouteSummary.propTypes = RouteSummaryPropTypes;

RouteSummary.defaultProps = RouteSummaryDefaultProps;

const mapStateToProps = state => ({
  directionsLoaded: state.Directions.directionsLoaded,
  shortName: state.Vehicle.shortName,
  isMobile: state.App.isMobile,
  modelCode: state.Vehicle.modelCode,
  CTA: state.RouteSummary.CTA,
  vehicleToggle: state.Vehicle.toggle,
  directionsIsLoading: state.Directions.directionsIsLoading,
  locale: state.App.locale,
  region: state.App.region,
});

export default connect(
  mapStateToProps,
  null,
)(RouteSummary);
